module.exports = __webpack_public_path__ + "a7140a24060780cfabedecec3a16661b.png";